import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumbs = ({ items, light = false }) => (
  <nav aria-label="Breadcrumb" className={`text-sm ${light ? 'text-slate-300' : 'text-slate-500'}`} data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1">
      <li className="flex items-center gap-1">
        <Link to="/" className={`${light ? 'hover:text-white' : 'hover:text-blue-600'} flex items-center gap-1`}><Home className="h-3.5 w-3.5" /> Home</Link>
      </li>
      {items.map((item, i) => (
        <li key={item.path || item.name} className="flex items-center gap-1">
          <ChevronRight className="h-3.5 w-3.5" />
          {i === items.length - 1 || !item.path ? (
            <span className={`font-medium ${light ? 'text-white' : 'text-slate-800'}`}>{item.name}</span>
          ) : (
            <Link to={item.path} className={light ? 'hover:text-white' : 'hover:text-blue-600'}>{item.name}</Link>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export default Breadcrumbs;
